<template>
  <div class="print-form">
    <div v-for="form in list" :key="form.length">
      <div v-for="page in pages(form)" :key="page">
        <p class="onetitle">出 仓 单</p>
        <div class="form-logo">
          <div><img :src="form.logoUrl" alt=""></div>
          <div>
            <div style="font-size: normal">
              {{ form.fCompany }}
            </div>
            <div
              style="
                font-size: 12px;
                -webkit-transform: scale(0.7);
                -webkit-transform-origin-x: 0;
              "
            >
              {{ form.fCompanyEnglish }}
            </div>
          </div>
        </div>
        <div class="form-info">
          <div>提货部门：{{ form.fBillingName }}</div>
          <div>
            客户名称：{{ form.fCustomer }}
            <span>NO：{{ form.fBillNo }}</span>
            <span>日期：{{ fmtDateTime(form.fCreateTime) }}</span>
          </div>
        </div>
        <table class="form-table">
          <thead>
            <tr style="font-size: 10px">
              <th style="width: 18mm">产品编号</th>
              <th>产品名称</th>
              <th>规格</th>
              <th style="width: 8mm">单位</th>
              <th style="width: 12mm">数量</th>
              <th style="width: 18mm">生产日期</th>
              <th style="width: 18mm">生产批号</th>
              <th style="width: 18mm">消毒日期</th>
              <th>追溯号</th>
              <th style="width: 18mm">发货日期</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(x, index) in items(form, page)"
              :key="index"
              style="text-align: center; font-size: 8px"
            >
              <td>{{ x.fNumber }}</td>
              <td>{{ x.fName }}</td>
              <td>{{ x.fModel }}</td>
              <td>{{ x.fUnit }}</td>
              <td>{{ x.fQty }}</td>
              <td>{{ x.fDate_Sc }}</td>
              <td>{{ x.fBatchNo }}</td>
              <td>{{ x.fDate_Xd }}</td>
              <td>{{ x.fRetroactiveNo }}</td>
              <td>{{ x.fDate_fh }}</td>
            </tr>
            <tr>
              <td style="text-align: center; font-size: 10px" colspan="3">
                发货方式及运费付款方式
              </td>
              <td colspan="7" style="font-size: 10px">{{ form.des1 }}</td>
            </tr>
            <tr>
              <td style="text-align: center; font-size: 10px" colspan="3">
                收件人、联系方式及地址
              </td>
              <td colspan="7" style="font-size: 10px">{{ form.des2 }}</td>
            </tr>
            <tr>
              <td style="text-align: center; font-size: 10px" colspan="3">
                备注
              </td>
              <td colspan="7" style="font-size: 10px">{{ form.des3 }}</td>
            </tr>
          </tbody>
        </table>
        <div class="form-foot">
          <span>记账：{{ form.jz }}</span>
          <span>会计：{{ form.kj }}</span>
          <span>出纳：{{ form.cn }}</span>
          <span>部门主管：{{ form.bmzg }}</span>
          <span>保管：{{ form.bg }}</span>
          <span>提货人：{{ form.thr }}</span>
        </div>
        <div
          style="text-align: center; margin-top: 5px; page-break-after: always"
        >
          <div>{{ page + 1 }}/{{ pages(form).length }}</div>
          <div>
            <span style="float: right; font-weight: bold; font-size: 14px">
              {{ form.fControlledNumber }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'

export default {
  data: function() {
    return {
      list: [],
      loading: false,
      pageSize: 5
    }
  },
  computed: {},

  methods: {
    pages: function(_form) {
      var count = Math.ceil(_form.stockEntrys.length / this.pageSize)
      var rtn = []
      for (let i = 0; i < count; i++) {
        rtn.push(i)
      }
      //   console.log('pages', rtn)
      return rtn
    },
    refresh: async function(val) {
      console.log(val, 'val')
      this.list = val.datalist
    },
    items: function(_form, page) {
      var rtn = []
      for (let i = 0; i < this.pageSize; i++) {
        const itemIdx = page * this.pageSize + i
        if (itemIdx >= _form.stockEntrys.length) break
        const item = _form.stockEntrys[itemIdx]
        rtn.push(item)
      }
      return rtn
    },
    fmtDateTime: function(dt) {
      var m = moment(dt, 'YYYY-MM-DD HH:mm:ss')
      return m.format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.print-form {
  .onetitle {
    font-weight: bold;
    font-size: 25px;
    font-family: 华文行楷;
    text-align: center;
    margin: 0;
  }

  .form-logo {
    display: flex;
    align-items: center;
  }

  .form-info {
    font-size: 10px;
    margin-bottom: 5px;
    span {
      float: right;
      margin-left: 35px;
    }
  }

  .form-table {
    width: 100%;
    border-collapse: collapse;
  }

  .form-table,
  th {
    border: 1px solid black;
    font-size: small;
  }
  .form-table,
  td {
    border: 1px solid black;
  }
  .form-foot {
    display: flex;
    font-size: 10px;
    margin-top: 5px;
    text-align: center;
    span {
      flex: 1;
      justify-content: space-between;
    }
  }
}
</style>
<style scoped media='print'>

    @page {
    margin: 1cm 4cm 0 1cm ;
  }
  </style>
